import { useTranslation } from 'react-i18next';

import { OpPage } from 'new-components/OpPage/OpPage';

import GuestPassReportTable from './GuestPassReportTable';

const GuestPassReport = () => {
  const { t } = useTranslation();
  return (
    <OpPage
      title={t('guestPassReport.title')}
      tooltip={t('guestPassReport.tooltip')}
    >
      <GuestPassReportTable />
    </OpPage>
  );
};

export default GuestPassReport;
